import { Alert, Avatar, Button, Card, Col, Divider, Image, Input, Modal, Row, Select, Spin, Table, Tag, Timeline, Typography } from 'antd';
import { Helmet } from 'react-helmet-async';
import { useEffect, useState } from 'react';
import { apiCall } from '../../API/RestApi';
import { modalError } from '../../Component/Modal/ModalLayout';
import { useSelector } from 'react-redux';
import Search from 'antd/es/input/Search';
import moment from 'moment';
import { MapContainer, Marker, TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import { dateFormat } from '../../Utils/formatDate';
import heic2any from "heic2any";

const { Option } = Select;
function DelegationAttendance() {
    const token = useSelector((state) => state.user.token);
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [loading, setLoading] = useState(false);
    const [statusFilter, setStatusFilter] = useState('');
    const [page, setPage] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    });
    const [isAlert, setIsAlert] = useState(false);
    const [textAlert, setTextAlert] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [detailData, setDetailData] = useState();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [convertedImage, setConvertedImage] = useState("");

    useEffect(() => {
        const convertHeic = async () => {
            if (!detailData?.image) return;

            try {
                const imageUrl = detailData.image;

                if (imageUrl.toLowerCase().endsWith(".heic")) {
                    const response = await fetch(imageUrl, { mode: "cors" });
                    const blob = await response.blob();

                    const converted = await heic2any({
                        blob,
                        toType: "image/jpeg",
                        quality: 0.9,
                    });

                    setConvertedImage(URL.createObjectURL(converted));
                } else {
                    setConvertedImage(imageUrl);
                }
            } catch (error) {
                console.error("Gagal konversi HEIC:", error);
                setConvertedImage(detailData.image);
            }
        };

        convertHeic();
    }, [detailData]);


    const titlePage = 'Attendance Delegation Data';
    const columns = [
        {
            title: 'No',
            dataIndex: 'no',
            key: "no",
            render: (id, record, index) => { ++index; return (page.pagination.current - 1) * page.pagination.pageSize + index },
        },
        {
            title: 'Image',
            dataIndex: 'image',
            key: "image",
            render: (text, record) => {
                if (record.image !== null && record.image !== '')
                    return <Image src={record.image} width={50} height={50} style={{ objectFit: 'cover', borderRadius: '8px' }} />;
                else
                    return 'No Image';
            }
        },
        {
            title: 'User Code',
            dataIndex: 'users_code',
            key: "users_code",
            render: (text, record) => record.user_attendance?.users_code
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: "name",
            render: (text, record) => record.user_attendance?.name
        },
        {
            title: 'Description',
            dataIndex: 'desc',
            key: "desc",
        },
        {
            title: 'Date',
            dataIndex: 'date',
            key: "date",
            render: (text, record) => (<p>{moment(record.date).format('DD-MM-YYYY')}</p>)
        },
        {
            title: 'Time',
            dataIndex: 'time',
            key: "time",
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: "status",
            render: (text, record) => {
                switch (record.status) {
                    case 'checkin':
                        return <Tag color='blue-inverse'>Clock In</Tag>
                    case 'checkout':
                        return <Tag color='pink-inverse'>Clock Out</Tag>
                }
            }
        },
        {
            title: 'Delegation Status',
            dataIndex: 'status_submission',
            key: "status_submission",
            render: (text, record) => {
                switch (record.attendance_approval[0].status_approval_id) {
                    case 2:
                        return <Tag color='green'>Approved</Tag>
                    case 3:
                        return <Tag color='red'>Rejected</Tag>
                    default:
                        return <Tag color='yellow'>{record.status_submission}</Tag>
                }
            }
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
                <Button type="default" onClick={() => showDetailModal(record)}>
                    <b>Detail</b>
                </Button>
            )
        }

    ];

    const showDetailModal = (data) => {
        getApi('GET', '/attendance/' + data.attendance_id, 'detail');
    };

    useEffect(() => {
        getApi("GET", '/historyattendance?userdelegation=true&search=' + search + '&page=' + page.pagination.current + '&statusDelegation=' + statusFilter, 'leave_paid');
    }, [JSON.stringify(page), isAlert, statusFilter]);

    const getApi = (method, url, type) => {
        setLoading(true);
        const dataReq = {
            method: method,
            url: url,
            data: {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        };
        apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                switch (type) {
                    case 'detail':
                        setDetailData(res.data);
                        setIsModalVisible(true);
                        break;
                    default:
                        setData(res.data.data);
                        setPage({
                            ...page,
                            pagination: {
                                ...page.pagination,
                                total: res.data.total_data
                            }
                        });
                        break;
                }
            }
            setLoading(false);
        }).catch((e) => {
            setLoading(false);
            console.log(e.message);
        });
    };

    const postApi = async (method, url, values) => {
        setLoading(true);
        setIsAlert(false);
        const dataReq = {
            method: method,
            url: url,
            data: {
                data: values,
                headers: {
                    Authorization: 'Bearer ' + token,
                }
            }
        };
        await apiCall(dataReq).then((res) => {
            if (res.status === "success") {
                setTextAlert(res.message);
                setIsAlert(true);
            } else {
                modalError(res.message);
            }
            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });
    };

    const handleBulkApprove = () => {
        if (selectedRowKeys.length === 0) return;
        Modal.confirm({
            title: 'Confirm Delegation',
            content: `Are you sure you want to approve ${selectedRowKeys.length} selected attendances?`,
            onOk: async () => {
                await postApi('PUT', '/attendanceapprovaldelegationbulk', {
                    ids: selectedRowKeys,
                    status_approval_id: 2,
                    reason: ""
                });
                setSelectedRowKeys([]);
                setIsAlert(true);
                setTextAlert('Selected attendances approved successfully.');
            }
        });
    };

    const handleBulkReject = () => {
        if (selectedRowKeys.length === 0) return;
        let reason = '';
        Modal.confirm({
            title: 'Reject Reason',
            content: (
                <Input.TextArea
                    rows={4}
                    style={{ width: '100%' }}
                    placeholder="Enter reason for rejection..."
                    onChange={(e) => reason = e.target.value}
                />
            ),
            onOk: async () => {
                if (!reason.trim()) {
                    modalError("Reason is required for rejection.");
                    return Promise.reject(); // Prevent modal from closing
                }

                await postApi('PUT', '/attendanceapprovaldelegationbulk', {
                    ids: selectedRowKeys,
                    status_approval_id: 3,
                    reason: reason
                });

                setSelectedRowKeys([]);
                setIsAlert(true);
                setTextAlert('Selected attendances rejected successfully.');
            }
        });
    };


    const handleTableChange = (pagination, filters, sorter) => {
        setPage({ pagination, filters, ...sorter });
        if (pagination.pageSize !== page.pagination?.pageSize) {
            setData([]);
        }
    };

    const searchData = (value) => {
        setSearch(value);
        setPage({ pagination: { current: 1, pageSize: 10 } });
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedKeys) => setSelectedRowKeys(selectedKeys),
        getCheckboxProps: (record) => ({
            disabled: record.status_submission !== 'Process' || record.attendance_approval[0].status_approval_id != 1,
        }),
    };

    return (
        <div>
            <Helmet>
                <title>{titlePage}</title>
            </Helmet>
            {isAlert && <Alert message={textAlert} type="success" banner closable afterClose={() => setIsAlert(false)} />}
            <h3>Attendance Delegation Data</h3>
            <Row>
                <Col span={8}>
                    <Search placeholder="Search" allowClear enterButton="Search" size="middle" onSearch={searchData} />

                </Col>
                <Col span={8}>
                    <Select
                        placeholder="Filter by status"
                        allowClear
                        style={{ width: 160, marginLeft:10 }}
                        onChange={setStatusFilter}
                    >
                        <Option value="Process">Process</Option>
                        <Option value="Approved">Approved</Option>
                        <Option value="Rejected">Rejected</Option>
                    </Select>
                </Col>
            </Row>
            <br />
            <Row style={{ marginBottom: 16 }}>
                <Col>
                    <Button type="primary" onClick={handleBulkApprove} disabled={selectedRowKeys.length === 0} style={{ marginRight: 10 }}>
                        Approve ({selectedRowKeys.length})
                    </Button>
                    <Button danger onClick={handleBulkReject} disabled={selectedRowKeys.length === 0}>
                        Reject ({selectedRowKeys.length})
                    </Button>
                </Col>
            </Row>

            <Table
                rowKey={(record) => record.attendance_id}
                rowSelection={rowSelection}
                size="middle"
                columns={columns}
                dataSource={data}
                pagination={page.pagination}
                loading={loading}
                onChange={handleTableChange}
            />


            <Modal
                title="Attendance Submission Detail"
                open={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                footer={null}
                width={900}
            >
                {loading ? (
                    <Spin tip="Loading..." style={{ display: "block", textAlign: "center" }} />
                ) : (
                    detailData && (
                        <Card>
                            <Typography.Title level={5}>Attendance Information</Typography.Title>
                            <Row gutter={[16, 16]}>
                                <Col span={12}>
                                    <Typography.Text strong>Employee Name:</Typography.Text>
                                    <Typography.Paragraph>{detailData.users?.name || '-'}</Typography.Paragraph>
                                </Col>
                                <Col span={12}>
                                    <Typography.Text strong>Attendance Status:</Typography.Text>
                                    <Typography.Paragraph>{detailData.status === 'checkin' ? 'Check In' : 'Check Out'}</Typography.Paragraph>
                                </Col>
                                <Col span={12}>
                                    <Typography.Text strong>Date:</Typography.Text>
                                    <Typography.Paragraph>{new Date(detailData.date).toLocaleDateString()}</Typography.Paragraph>
                                </Col>
                                <Col span={12}>
                                    <Typography.Text strong>Time:</Typography.Text>
                                    <Typography.Paragraph>{detailData.time}</Typography.Paragraph>
                                </Col>
                                <Col span={12}>
                                    <Typography.Text strong>Late Status:</Typography.Text>
                                    <Typography.Paragraph>{detailData.is_late ? 'Late' : 'On Time'}</Typography.Paragraph>
                                </Col>
                                <Col span={12}>
                                    <Typography.Text strong>Submitted By:</Typography.Text>
                                    <Typography.Paragraph>{detailData.users?.name || '-'}</Typography.Paragraph>
                                </Col>
                                <Col span={24}>
                                    <Typography.Text strong>Note:</Typography.Text>
                                    <Typography.Paragraph>{detailData.desc || '-'}</Typography.Paragraph>
                                </Col>
                            </Row>

                            <Divider />

                            <Typography.Title level={5}>Shift</Typography.Title>
                            <Row gutter={[16, 16]}>
                                <Col span={12}>
                                    <Typography.Text strong>Shift Name:</Typography.Text>
                                    <Typography.Paragraph>{detailData.shift?.name || '-'}</Typography.Paragraph>
                                </Col>
                                <Col span={6}>
                                    <Typography.Text strong>Start:</Typography.Text>
                                    <Typography.Paragraph>{detailData.shift?.time_in}</Typography.Paragraph>
                                </Col>
                                <Col span={6}>
                                    <Typography.Text strong>End:</Typography.Text>
                                    <Typography.Paragraph>{detailData.shift?.time_out}</Typography.Paragraph>
                                </Col>
                            </Row>

                            <Divider />

                            <Typography.Title level={5}>Location & Evidence</Typography.Title>
                            <Row gutter={[16, 16]}>
                                <Col span={12}>
                                    <div style={{ height: '250px', width: '100%', borderRadius: 10, overflow: 'hidden' }}>
                                        <MapContainer
                                            center={[parseFloat(detailData.latitude), parseFloat(detailData.longitude)]}
                                            zoom={16}
                                            style={{ height: '100%', width: '100%' }}
                                            scrollWheelZoom={false}
                                        >
                                            <TileLayer
                                                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                                attribution="&copy; OpenStreetMap contributors"
                                            />
                                            <Marker position={[parseFloat(detailData.latitude), parseFloat(detailData.longitude)]} />
                                        </MapContainer>
                                    </div>
                                </Col>
                                <Col span={12}>
                                    <Image
                                        alt="Attendance Evidence"
                                        src={convertedImage || detailData.image}
                                        width={250}
                                        height={250}
                                        style={{
                                            objectFit: "contain",
                                            borderRadius: "10px",
                                            border: '1px solid #F2F2F2'
                                        }}
                                    />
                                </Col>
                            </Row>

                            <Divider />

                            <Typography.Title level={5}>Delegation</Typography.Title>
                            <Timeline mode="left" style={{ marginTop: 20 }}>
                                {/* Requested */}
                                <Timeline.Item color="blue">
                                    <Row gutter={8} align="middle">
                                        <Col>
                                            <Avatar src={detailData.users?.image} />
                                        </Col>
                                        <Col>
                                            <Typography.Text strong>{detailData.users?.name || "-"}</Typography.Text><br />
                                            <Tag color="blue">Process</Tag><br />
                                            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                                {dateFormat(detailData.created_at) || "-"}
                                            </Typography.Text>
                                        </Col>
                                    </Row>
                                </Timeline.Item>

                                {/* Delegation Timeline */}
                                {detailData.attendance_approval.map((approval) => (
                                    <Timeline.Item
                                        key={approval.attendance_approval_id}
                                        color={
                                            approval.status_approval_id === 2
                                                ? "green"
                                                : approval.status_approval_id === 3
                                                    ? "red"
                                                    : "yellow"
                                        }
                                    >
                                        <Row gutter={8} align="middle">
                                            <Col>
                                                <Avatar src={approval.user?.image} />
                                            </Col>
                                            <Col>
                                                <Typography.Text strong>{approval.user?.name || "-"}</Typography.Text><br />
                                                {detailData.users.users_id === approval.user?.users_id ? (
                                                    <Tag color="red">Dibatalkan</Tag>
                                                ) : (
                                                    <Tag
                                                        color={
                                                            approval.status_approval_id === 2
                                                                ? "green"
                                                                : approval.status_approval_id === 3
                                                                    ? "red"
                                                                    : "yellow"
                                                        }
                                                    >
                                                        {approval.status_approval?.status}
                                                    </Tag>
                                                )}
                                                <br />
                                                <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                                                    {dateFormat(approval.created_at) || "-"}
                                                </Typography.Text>
                                            </Col>
                                        </Row>
                                    </Timeline.Item>
                                ))}
                            </Timeline>
                        </Card>
                    )
                )}
            </Modal>
        </div>
    );
}

export default DelegationAttendance;
